// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3N03G","footer":"ModalCreateQualiphyProcedure_footer__E7e9U","additionData":"ModalCreateQualiphyProcedure_additionData__3dvWd"};